var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQualityAssurance1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2162 1461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#7d97f4;}.cls-14,.cls-3{fill:#91b3fa;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-5);}.cls-8{fill:#bdd0fb;}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:url(#linear-gradient-7);}.cls-11{fill:url(#linear-gradient-8);}.cls-12{fill:#18174a;}.cls-13{fill:#2b69b3;}.cls-14{opacity:0.52;}.cls-15{fill:url(#linear-gradient-9);}.cls-16{fill:url(#linear-gradient-10);}.cls-17{fill:url(#linear-gradient-11);}.cls-18{fill:url(#linear-gradient-12);}.cls-19{fill:url(#linear-gradient-13);}.cls-20{fill:url(#linear-gradient-14);}.cls-21{fill:url(#linear-gradient-15);}.cls-22,.cls-25{fill:#fff;}.cls-22{opacity:0.7;}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-26{fill:url(#linear-gradient-18);}.cls-27{fill:url(#linear-gradient-19);}.cls-28{fill:url(#linear-gradient-20);}.cls-29{fill:url(#linear-gradient-21);}.cls-30{fill:url(#linear-gradient-22);}.cls-31{fill:url(#linear-gradient-23);}.cls-32{fill:url(#linear-gradient-24);}.cls-33{fill:url(#linear-gradient-25);}.cls-34{fill:url(#linear-gradient-26);}.cls-35{fill:url(#linear-gradient-27);}.cls-36{fill:url(#linear-gradient-28);}.cls-37{fill:url(#linear-gradient-29);}.cls-38{fill:url(#linear-gradient-30);}.cls-39{fill:url(#linear-gradient-31);}.cls-40{fill:url(#linear-gradient-32);}.cls-41{fill:url(#linear-gradient-33);}.cls-42{fill:url(#linear-gradient-34);}.cls-43{fill:url(#linear-gradient-35);}.cls-44{fill:url(#linear-gradient-36);}.cls-45{fill:url(#linear-gradient-37);}.cls-46{fill:url(#linear-gradient-38);}.cls-47{fill:url(#_32);}.cls-48{opacity:0.2;fill:url(#linear-gradient-39);}.cls-49{fill:url(#linear-gradient-40);}.cls-50{fill:url(#linear-gradient-41);}.cls-51{fill:url(#linear-gradient-42);}.cls-52{fill:url(#linear-gradient-43);}.cls-53{fill:url(#linear-gradient-44);}.cls-54{fill:url(#linear-gradient-45);}.cls-55{fill:url(#linear-gradient-46);}.cls-56{fill:url(#linear-gradient-47);}.cls-57{fill:url(#linear-gradient-48);}.cls-58{fill:url(#linear-gradient-49);}.cls-59{fill:url(#linear-gradient-50);}.cls-60{fill:url(#linear-gradient-51);}.cls-61{fill:url(#linear-gradient-52);}.cls-62{fill:url(#linear-gradient-53);}.cls-63{fill:url(#linear-gradient-54);}.cls-64{fill:url(#linear-gradient-55);}.cls-65{fill:url(#linear-gradient-56);}.cls-66{fill:url(#linear-gradient-57);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.47,
    y1: 692.96,
    x2: 2144.41,
    y2: 692.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dae3fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9effd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 181.38,
    y1: 669.11,
    x2: 525.4,
    y2: 669.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 185.93,
    y1: 706.65,
    x2: 488.88,
    y2: 706.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 107.13,
    y1: 1025.92,
    x2: 551.11,
    y2: 1025.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 116.47,
    y1: 793.72,
    x2: 546.09,
    y2: 793.72,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 255.71,
    y1: 566.7,
    x2: 408.34,
    y2: 566.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 1820.2,
    y1: 640.45,
    x2: 2050.38,
    y2: 640.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 190.46,
    y1: 1045.08,
    x2: 665.26,
    y2: 1045.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 301.65,
    y1: 1034.13,
    x2: 645.67,
    y2: 1034.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 338.16,
    y1: 1061.86,
    x2: 641.12,
    y2: 1061.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 275.94,
    y1: 1204.31,
    x2: 719.91,
    y2: 1204.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 280.96,
    y1: 1126.19,
    x2: 710.57,
    y2: 1126.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 598.96,
    y1: 1264.43,
    x2: 956.83,
    y2: 1264.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 610.04,
    y1: 1296.48,
    x2: 951.76,
    y2: 1296.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 1418.61,
    y1: 1015.26,
    x2: 2016.2,
    y2: 1015.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7062"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff928e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 1528.02,
    y1: 719.95,
    x2: 1927.2,
    y2: 719.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1527.8,
    y1: 745.79,
    x2: 1926.99,
    y2: 745.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1533.35,
    y1: 938.78,
    x2: 1598.33,
    y2: 938.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1637.31,
    y1: 939.89,
    x2: 1913.55,
    y2: 939.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 363.56,
    y1: 6377.31,
    x2: 98.42,
    y2: 6829.85,
    gradientTransform: "translate(1172.33 -5663.34) rotate(-1.38)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1535.37,
    y1: 822.17,
    x2: 1600.35,
    y2: 822.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1639.32,
    y1: 823.28,
    x2: 1915.57,
    y2: 823.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 368.38,
    y1: 6260.79,
    x2: 103.24,
    y2: 6713.33,
    gradientTransform: "translate(1172.33 -5663.34) rotate(-1.38)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1536.04,
    y1: 1050.04,
    x2: 1601.01,
    y2: 1050.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1639.99,
    y1: 1051.15,
    x2: 1916.24,
    y2: 1051.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 412.1,
    y1: 6405.75,
    x2: 146.96,
    y2: 6858.29,
    gradientTransform: "translate(1172.33 -5663.34) rotate(-1.38)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 1533.76,
    y1: 1157,
    x2: 1598.73,
    y2: 1157,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1637.71,
    y1: 1158.11,
    x2: 1913.96,
    y2: 1158.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 448.06,
    y1: 6512.88,
    x2: 99.19,
    y2: 6999.31,
    gradientTransform: "translate(1172.33 -5663.34) rotate(-1.38)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 1530.52,
    y1: 1267.32,
    x2: 1595.5,
    y2: 1267.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 1634.47,
    y1: 1268.43,
    x2: 1910.72,
    y2: 1268.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 498.43,
    y1: 6457.12,
    x2: 233.29,
    y2: 6909.66,
    gradientTransform: "translate(1172.33 -5663.34) rotate(-1.38)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 863.93,
    y1: 1017.28,
    x2: 681.53,
    y2: 1321.93,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 837.77,
    y1: 699.41,
    x2: 871.24,
    y2: 1103.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0f91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 9507.62,
    y1: 1055.46,
    x2: 9428.02,
    y2: 1125.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 10417.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 900.29,
    y1: 1039.05,
    x2: 717.89,
    y2: 1343.69,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 803.19,
    y1: 980.91,
    x2: 620.79,
    y2: 1285.56,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 9656.85,
    y1: 1062.13,
    x2: 9719.54,
    y2: 1062.13,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_32",
    x1: 809.61,
    y1: 879.93,
    x2: 840.66,
    y2: 986.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff928e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#ff9592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb3b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 9731.88,
    y1: 962.49,
    x2: 10033.22,
    y2: 962.49,
    gradientTransform: "matrix(-1, 0, 0, 1, 10417.91, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b37cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f895e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 9539.06,
    y1: 1090.96,
    x2: 9459.46,
    y2: 1161.45,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 9712.88,
    y1: 1054.77,
    x2: 9735.33,
    y2: 1054.77,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 5004.51,
    y1: 5103.07,
    x2: 5044.29,
    y2: 5029.34,
    gradientTransform: "matrix(-1, 0, 0, 1, 8084.91, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 4990.12,
    y1: 5095.3,
    x2: 5029.9,
    y2: 5021.57,
    gradientTransform: "matrix(-1, 0, 0, 1, 8084.91, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 666.83,
    y1: 643.2,
    x2: 463.99,
    y2: 1150.32,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -329.26,
    y1: 4143.04,
    x2: 35.54,
    y2: 3923.77,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, 8295.44, 82.13)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -351.45,
    y1: 4106.11,
    x2: 13.35,
    y2: 3886.84,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, 8295.44, 82.13)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -374.93,
    y1: 4067.06,
    x2: -10.13,
    y2: 3847.79,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, 8295.44, 82.13)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -397.43,
    y1: 4029.62,
    x2: -32.63,
    y2: 3810.35,
    gradientTransform: "matrix(-1, 0.07, 0.07, 1, 8295.44, 82.13)",
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 1554.63,
    y1: 557.52,
    x2: 1919.43,
    y2: 338.25,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 1831.95,
    y1: 381.86,
    x2: 1909.57,
    y2: 603.07,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 6375.2,
    y1: 2024.91,
    x2: 6447,
    y2: 1731.91,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 6725.11,
    y1: 713.97,
    x2: 6678.56,
    y2: 1016.61,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 6626.6,
    y1: 698.81,
    x2: 6580.04,
    y2: 1001.45,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 6301.01,
    y1: 2006.73,
    x2: 6372.81,
    y2: 1713.73,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 6555.34,
    y1: 575.07,
    x2: 6588.66,
    y2: 575.07,
    gradientTransform: "translate(-4693.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 6562.46,
    y1: 528.9,
    x2: 6804.96,
    y2: 545.39,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 5937.91,
    y1: -1009.77,
    x2: 6015.52,
    y2: -788.56,
    gradientTransform: "translate(-4693.69)",
    xlinkHref: "#linear-gradient-35"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.61,1363.12s-190.4-25.34-280.81-5.55-314.36-87.55-240.14-256,158.26-272.84,61.17-365S-38.81,469.06,61.31,370.47s130.25,2.85,210-33.46S249.79,111.31,475.12,57.78s393.58,80.62,496,62.35S1237.94,17.48,1348.5,22.19s96.85,169.55,243.55,159.94S1853.92,155.92,1949,296.24s72.18,318.3-18.43,388.63-72.93,164.92,94.13,170.35,148.25,201.6,11.92,346.42-253.27,146.43-389.44,155.93S548.61,1363.12,548.61,1363.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M566,1364.59H90.79a27.45,27.45,0,0,1-27.44-27.44V625.46A27.44,27.44,0,0,1,90.72,598l479-1.29a27.44,27.44,0,0,1,27.51,27.59l-3.8,713A27.44,27.44,0,0,1,566,1364.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M542.67,631.86,117.8,634.48a27.84,27.84,0,0,0-27.67,28l3,638.77a27.84,27.84,0,0,0,27.33,27.7l412.81,7.53A27.84,27.84,0,0,0,561.59,1309l9.09-648.91A27.84,27.84,0,0,0,542.67,631.86Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 181.38,
    y: 659.32,
    width: 344.02,
    height: 19.59,
    rx: 8.33
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M488.87,704.49h0a8.33,8.33,0,0,1-8.16,7.88l-286.3,5.21a8.32,8.32,0,0,1-8.48-8.32v-.68a8.33,8.33,0,0,1,8.2-8.33l286.29-4.54A8.34,8.34,0,0,1,488.87,704.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M517.8,1314.62,130.58,1310a23.73,23.73,0,0,1-23.44-24.18l10-525.3a23.73,23.73,0,0,1,24.19-23.28l386.55,7.53a23.77,23.77,0,0,1,23.27,24.15h0l-9.3,522.43a23.78,23.78,0,0,1-23.72,23.31ZM129.85,749.53A15.72,15.72,0,0,0,125,760.64l-10,525.3a15.84,15.84,0,0,0,15.64,16.14l387.23,4.64a15.8,15.8,0,0,0,16-15.55l9.29-522.43h0a15.86,15.86,0,0,0-15.52-16.11l-386.56-7.52h-.31A15.73,15.73,0,0,0,129.85,749.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.42,797.67H542.14a4,4,0,1,0,0-7.9H120.42a4,4,0,0,0,0,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.38,135.56c-29.1,87.09-177.72,600.81,279.29,826.87,0,0,184.91-313-266.08-829.54A7.77,7.77,0,0,0,227.38,135.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M255.72,223.26c2.28,29.27,5.16,58.45,8.3,87.62s6.64,58.3,10.46,87.39c7.66,58.17,16.61,116.19,27.35,173.9S325.07,687.29,340.67,744q11.55,42.54,26.25,84.2c9.84,27.72,20.81,55.12,33.94,81.59a3.94,3.94,0,1,0,7.07-3.5v0h0c-13.11-26-24.15-53.07-34.1-80.52S355,770.33,347.17,742.15c-15.88-56.32-28.69-113.52-39.82-171S287,455.72,278.93,397.67q-6-43.55-11-87.22c-3.32-29.11-6.39-58.27-8.86-87.45h0a1.67,1.67,0,1,0-3.33.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M2057,158.67c-2.23-7.44-13-6.95-14.48.67C2028,233,1983.73,425,1900.83,531.6c-135,173.52-212.6,444.14-107.27,572.86C1793.56,1104.46,2299.67,969.57,2057,158.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M2050.38,262.7c0,2.27-.21,4.26-.33,6.36l-.5,6.21-1.13,12.4c-.81,8.27-1.7,16.52-2.61,24.77q-2.8,24.75-6.18,49.42c-4.51,32.9-9.88,65.68-15.75,98.36s-12.54,65.23-19.9,97.62L2001.24,570l-2.9,12.12c-2,8.07-3.79,16.17-5.89,24.21l-6.15,24.14-6.5,24c-17.69,64-38.74,127.22-64.19,188.64-1.54,3.86-3.2,7.67-4.89,11.46l-5,11.41-5,11.41c-1.72,3.79-3.54,7.52-5.31,11.29-3.59,7.49-7,15.06-10.75,22.48l-11.35,22.2a879.49,879.49,0,0,1-51.54,85.28.85.85,0,0,1-1.41-.94h0a947.29,947.29,0,0,0,49.84-85.94l11.07-22.24c3.65-7.43,7-15,10.49-22.52,1.72-3.76,3.49-7.51,5.16-11.29l4.88-11.43,4.88-11.42c1.65-3.8,3.26-7.61,4.76-11.47l9.21-23.07c3-7.71,5.84-15.5,8.77-23.25,1.44-3.88,2.93-7.75,4.33-11.65l4.1-11.72,4.1-11.73c1.38-3.9,2.73-7.82,4-11.77,10.59-31.39,19.93-63.2,29-95.08,17.81-63.85,32.34-128.59,44.83-193.7q9.29-48.85,16.67-98.06,3.73-24.58,7-49.25c1.05-8.22,2.07-16.45,3-24.69l1.33-12.36.59-6.18c.17-2,.38-4.17.44-6.06v-.18a.84.84,0,0,1,1.67,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M695.94,1337s-5.24-110.77-119.8-220C469.86,1015.64,209,781.53,146.82,649.73a6,6,0,0,0-11.37,2.6c1.12,69.23,17.54,242.42,141.69,411.74C437.23,1282.43,695.94,1337,695.94,1337Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M190.46,772.58c2.36,15.14,6.6,29.94,11.64,44.4.62,1.82,1.2,3.64,1.85,5.45l2.05,5.36,4.12,10.75,4.56,10.56c1.55,3.5,3,7.08,4.73,10.49A542.12,542.12,0,0,0,265.78,939c4.18,6.46,9,12.44,13.6,18.59s9.12,12.37,14.18,18.14l14.79,17.66c2.41,3,5.11,5.73,7.71,8.56l7.84,8.43,7.85,8.43,3.94,4.2,4.12,4,16.5,16.07c2.77,2.65,5.46,5.41,8.3,8l8.49,7.72,17,15.45,17.16,15.25c5.73,5.07,11.42,10.19,17.23,15.17q17.31,15.08,34.86,29.87c11.66,9.92,23.46,19.64,35.22,29.43l35.56,29c23.73,19.29,47.47,38.53,70.53,58.51,5.84,4.92,11.42,10.11,17.09,15.21,2.86,2.52,5.55,5.22,8.3,7.85s5.51,5.26,8.17,8c5.2,5.55,10.61,10.93,15.41,16.83l3.71,4.34c.61.73,1.26,1.43,1.83,2.19l1.7,2.28,6.82,9.16,0,0a.87.87,0,0,0,1.22.17.87.87,0,0,0,.21-1.17,270.87,270.87,0,0,0-28.71-36c-2.61-2.81-5.36-5.49-8-8.24s-5.35-5.5-8.17-8.1c-5.57-5.26-11.06-10.62-16.8-15.69-22.73-20.56-46.35-40-69.77-59.68s-46.9-39.21-70.12-59.06-46.18-40-68.95-60.35l-16.93-15.42-8.47-7.72c-2.83-2.56-5.51-5.26-8.27-7.88l-16.45-15.84-4.11-4-3.92-4.14L328.6,1006a672.39,672.39,0,0,1-58.39-70.11,537.57,537.57,0,0,1-47.69-77.8c-1.83-3.35-3.29-6.87-5-10.29l-4.88-10.34-4.45-10.53L206,821.65c-.71-1.77-1.35-3.56-2-5.35-1.31-3.57-2.73-7.12-3.95-10.73l-3.57-10.87a222.37,222.37,0,0,1-5.77-22.15.11.11,0,0,0-.12-.09A.12.12,0,0,0,190.46,772.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1076.03 1063.61 1047.31 1321.19 1380.52 1321.19 1337.12 1063.61 1076.03 1063.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M377.08,301.35v708.58A107.5,107.5,0,0,0,481.8,1117.39c258.81,6.67,1164,22.85,1410.36,19.22a79.1,79.1,0,0,0,77.87-76.84c4.75-164.61,12.46-560.45-16.09-744.22a81.39,81.39,0,0,0-77.82-68.89c-216.85-6.94-1176.4-29-1422.66-23.44A78.14,78.14,0,0,0,377.08,301.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M421.54,297.9V971.1a62.28,62.28,0,0,0,61.35,62.27l1373.82,17A60.61,60.61,0,0,0,1918.23,990l2.3-667.18a44.33,44.33,0,0,0-43.25-44.48L470.74,249.88A48,48,0,0,0,421.54,297.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M460.52,319.26V951.12c0,31.94,26,58,58.41,58.44L1827,1025.5c32.13.47,58.46-25,58.58-56.68l2.18-626.2c.09-22.65-18.21-41.2-41.18-41.75L507.36,274.2C481.67,273.58,460.52,293.94,460.52,319.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1928.57,1078.13h0l-1507-25.68a2.11,2.11,0,0,1,.07-4.21l1507,25.68a2.11,2.11,0,0,1,0,4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1189.93,1109.49a17.79,17.79,0,1,1,17.78-17.78A17.81,17.81,0,0,1,1189.93,1109.49Zm0-31.36a13.58,13.58,0,1,0,13.57,13.58A13.59,13.59,0,0,0,1189.93,1078.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1452.29,1373.89H964.62c-13.25,0-23.2-9.43-20.64-19.56l6.26-24.75c1.88-7.44,10.07-12.91,19.8-13.21l470.13-14.67c10.16-.32,19.16,5.08,21.37,12.81l11.28,39.42C1475.75,1364.17,1465.75,1373.89,1452.29,1373.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1227.14,1323.59a2.11,2.11,0,0,1,0-4.21l20.15-.3a2.19,2.19,0,0,1,2.14,2.08,2.12,2.12,0,0,1-2.08,2.14l-20.15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M962,1360.76l-.33,0a2.12,2.12,0,0,1-1.75-2.42l2.87-18A20.59,20.59,0,0,1,982.9,1323l213.68-3.13a2.1,2.1,0,0,1,2.14,2.08,2.12,2.12,0,0,1-2.08,2.14L983,1327.16A16.39,16.39,0,0,0,967,1341l-2.87,18A2.11,2.11,0,0,1,962,1360.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M994.07,816.8l-502.13,6c-19.34.23-34.59,12.75-33.64,27.63l8.36,131.49c.89,14,15.92,25.06,34.16,25.06H994.6c18.89,0,34.21-11.8,34.21-26.35V843.13C1028.81,828.43,1013.17,816.57,994.07,816.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1614.06,780.22l-502.14,7.3c-19.34.29-34.58,15.61-33.63,33.81l8.36,160.9c.89,17.17,15.92,30.65,34.16,30.65h493.78c18.89,0,34.2-14.43,34.2-32.23V812.44C1648.79,794.45,1633.16,779.94,1614.06,780.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1265.19,434.28H489.81c-12.05,0-21.81,9.18-21.81,20.49V654c0,11.32,9.76,20.49,21.81,20.49h775.38c12,0,21.81-9.17,21.81-20.49V454.77C1287,443.46,1277.24,434.28,1265.19,434.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1843.53,445.49H1533.35a10.7,10.7,0,0,0-2.71.25c-25.93,6.8-34.66-14.94-44.74,18.08-.4,1.32.53,2.72.53,4.11V665.19c0,11.32,20.4,20.49,45.57,20.49h311.53c25.16,0,45.57-9.17,45.57-20.49V466C1889.1,454.66,1868.69,445.49,1843.53,445.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.09,1361.1H736.26c15.15,0,27.43-9.08,27.43-20.27V1001.88c0-11.17-12.24-20.24-27.36-20.27l-479-1c-15.24,0-27.59,9.12-27.51,20.38l3.8,339.9C233.74,1352.09,246,1361.1,261.09,1361.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M284.38,1006.61l424.87,1.93c15.36.07,27.74,9.31,27.67,20.66l-3,285.07c-.07,11.18-12.2,20.27-27.33,20.47L293.8,1340.3c-15.41.21-28.12-8.88-28.34-20.27l-9.09-292.57C256.15,1015.94,268.78,1006.54,284.38,1006.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M301.65,1033.05v2.16c0,3.4,3.73,6.15,8.33,6.15H637.34c4.6,0,8.33-2.75,8.33-6.15v-2.16c0-3.4-3.73-6.16-8.33-6.16H310C305.38,1026.89,301.65,1029.65,301.65,1033.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M338.18,1060.26h0c.23,3.22,3.8,5.76,8.16,5.82l286.3,3.86c4.65.06,8.48-2.71,8.48-6.15v-.51c0-3.36-3.65-6.1-8.2-6.15l-286.29-3.35C341.8,1053.72,337.92,1056.7,338.18,1060.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M285.24,1307.09,276,1108s0-.06,0-.09a16.16,16.16,0,0,1,4.75-11.55c4.4-4.57,11.16-7.26,18.54-7.36l386.55-5.56h.44c12.87,0,23.46,8.08,23.72,18.08l10,201.35a16.12,16.12,0,0,1-4.77,11.6c-4.45,4.6-11.25,7.27-18.68,7.34l-387.23,3.43h-.29C295.87,1325.21,285.48,1317.26,285.24,1307.09ZM685.89,1091.3l-386.55,5.56c-5.21.08-10,1.92-13,4.94a8.38,8.38,0,0,0-2.55,5.85l9.3,199.17c.13,5.72,7.36,10.5,15.83,10.5h.2l387.23-3.44c5.24,0,10.13-1.88,13.07-4.92a8.34,8.34,0,0,0,2.56-5.82l-10-201.35c-.15-5.73-7.36-10.49-15.83-10.49Zm-406,16.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M284.91,1130.13H706.63a3.95,3.95,0,0,0,0-7.89H284.91a3.95,3.95,0,1,0,0,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1024,1235.81l-3.7,132c-.29,10.26-14.24,18.48-31.34,18.48H556.74c-17.31,0-31.35-8.41-31.35-18.79V1244c0-10.14,13.43-18.45,30.34-18.78l435.9-8.46C1009.54,1216.36,1024.29,1225.07,1024,1235.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M988.21,1248.67l-9.38,121.39c-.36,4.66-6.84,8.31-14.62,8.23l-393.57-4.16c-7.84-.08-14.13-3.92-14.13-8.62V1260.23c0-4.6,6-8.39,13.68-8.61l402.94-12C981.61,1239.41,988.6,1243.59,988.21,1248.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M956.83,1260.05v8.75c0,3.08-4.22,5.57-9.36,5.52L608,1271c-5,0-9.06-2.51-9.06-5.52h0c0-3,4-5.44,9-5.52l339.46-5.42C952.55,1254.46,956.83,1257,956.83,1260.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M951.76,1293.08v8c0,3.12-4.32,5.62-9.53,5.51l-323.31-6.75c-4.95-.1-8.88-2.54-8.88-5.52v-2.5c0-3.06,4.16-5.53,9.26-5.51l323.31,1.23C947.67,1287.59,951.76,1290.05,951.76,1293.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M1478.87,634.87l461.4,3.81a47.81,47.81,0,0,1,47.37,45.76l28.53,669.23a35.25,35.25,0,0,1-34.87,36.75l-528.9,5.24a33.45,33.45,0,0,1-33.79-33.73l5.56-673.26A54.25,54.25,0,0,1,1478.87,634.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1529.77,1385.17h0l-59.17-1.25a36.74,36.74,0,0,1-35.82-36.89l.74-89.34a1.51,1.51,0,1,1,3,0l-.73,89.34a33.72,33.72,0,0,0,32.87,33.86l59.16,1.25a1.51,1.51,0,1,1,0,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M1437.22,1231.53a1.5,1.5,0,0,1-1.48-1.52l.12-14.46a1.51,1.51,0,0,1,1.52-1.5h0a1.5,1.5,0,0,1,1.48,1.52l-.12,14.47a1.49,1.49,0,0,1-1.52,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1480.34,629.45c62.93,9.07,279.39,37.29,458.64,25a14.58,14.58,0,0,1,15.58,13.88l30.16,672.22a16.76,16.76,0,0,1-15.9,17.51c-75.38,3.83-385.81,18.51-496.39,6a13.29,13.29,0,0,1-11.78-13.25L1462.33,645A15.77,15.77,0,0,1,1480.34,629.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1486.94,646.94c60.57,8.72,268.87,35.88,441.37,24.07a14,14,0,0,1,15,13.35l29,646.91a16.14,16.14,0,0,1-15.3,16.85c-72.54,3.69-371.28,17.81-477.69,5.77a12.78,12.78,0,0,1-11.34-12.74l1.61-679.22A15.18,15.18,0,0,1,1486.94,646.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M1923.42,727.78a3.7,3.7,0,0,0,3.77-4l-.07-1.32a4.38,4.38,0,0,0-4.23-4l-392.64-6.34c-2.2,0-2.89,1.35-1.54,3.08l4.89,6.25a9.41,9.41,0,0,0,6.46,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M1530,738c-2.2,0-2.89,1.36-1.53,3.09l4.89,6.24a9.41,9.41,0,0,0,6.46,3.18l383.36,3.17a3.71,3.71,0,0,0,3.77-4l-.08-1.32a4.38,4.38,0,0,0-4.23-4.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1596.13,973.39H1596l-51.93.76c-7.48.1-13.78-4.9-14.65-11.64l-5.62-43.45a9.6,9.6,0,0,1,2.09-7.26,11.52,11.52,0,0,1,7.94-4.16h0c4.37-.4,10.39-1.06,17-1.79,14.42-1.58,30.76-3.37,40.38-3.72h.22c6.88-.16,12.9,3.89,14.69,9.92,3,10,3.17,28.89,3.14,49.07C1609.25,967.73,1603.37,973.21,1596.13,973.39Zm-61.92-61.53a7.29,7.29,0,0,0-5,2.58,5.41,5.41,0,0,0-1.19,4.08l5.61,43.45c.59,4.6,5.06,8,10.39,7.94l51.93-.75h.1c5-.12,9-3.71,9-8,0-19.86-.17-38.46-3-47.87-1.24-4.16-5.83-7.17-10.69-6.88-9.47.35-26.44,2.21-40.08,3.7-6.65.73-12.69,1.39-17.08,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M1539.89,916.1c10.89-1,34.53-4,45.77-4.4,4.76-.18,9,2.6,10.23,6.7,2.36,8,2.46,24,2.44,38.74,0,4.42-4,8.05-8.94,8.12l-41.49.6c-5.11.08-9.43-3.3-10-7.82l-4.49-34.72C1532.94,919.73,1535.86,916.47,1539.89,916.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1640.35,927.09a2.85,2.85,0,0,0-2.89,3.84l5.24,18.1a5.49,5.49,0,0,0,5.11,3.74l261.92-6.32a3.91,3.91,0,0,0,3.82-4.09L1913,931a4.26,4.26,0,0,0-4.19-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1542.27,922.87h0a8,8,0,0,1,11.06,2.73L1564,943.71a2.56,2.56,0,0,0,4.56-.31l24-57.16a2.84,2.84,0,0,1,5.45,1.1c.16,17.3-3.64,50.29-30.61,78.47,0,0-15.37-5.55-28.28-32.19A8.35,8.35,0,0,1,1542.27,922.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1598.14,856.78H1598l-51.93.75c-7.48.11-13.78-4.89-14.65-11.63l-5.61-43.45a9.6,9.6,0,0,1,2.09-7.27,11.53,11.53,0,0,1,7.93-4.15h0c4.37-.41,10.39-1.07,17-1.79,14.42-1.58,30.76-3.37,40.38-3.72h.21c6.88-.17,12.9,3.89,14.69,9.91,2.95,10,3.17,28.9,3.14,49.08C1611.26,851.12,1605.39,856.6,1598.14,856.78Zm-61.92-61.53a7.27,7.27,0,0,0-5,2.58,5.38,5.38,0,0,0-1.2,4.08l5.61,43.45c.6,4.6,5.07,8,10.39,7.94l51.93-.76h.1c5-.12,9-3.71,9-8,0-19.86-.18-38.47-3-47.87-1.24-4.17-5.82-7.17-10.69-6.88-9.46.35-26.43,2.21-40.07,3.7-6.65.73-12.7,1.39-17.09,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1541.91,799.48c10.88-1,34.53-4,45.77-4.39,4.76-.18,9,2.6,10.22,6.7,2.37,8,2.46,24,2.44,38.74,0,4.42-4,8.05-8.94,8.12l-41.49.6c-5.1.08-9.42-3.3-10-7.82l-4.48-34.72C1535,803.12,1537.87,799.86,1541.91,799.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1642.36,810.48a2.85,2.85,0,0,0-2.89,3.84l5.25,18.09a5.48,5.48,0,0,0,5.11,3.75l261.92-6.32a3.9,3.9,0,0,0,3.81-4.09l-.52-11.37a4.24,4.24,0,0,0-4.18-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1544.28,806.26h0a8,8,0,0,1,11.06,2.73l10.69,18.1a2.55,2.55,0,0,0,4.56-.3l24-57.16a2.84,2.84,0,0,1,5.45,1.1c.16,17.3-3.64,50.28-30.61,78.47,0,0-15.37-5.55-28.28-32.19A8.36,8.36,0,0,1,1544.28,806.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1598.81,1084.65h-.14l-51.93.75c-7.48.11-13.78-4.89-14.65-11.63l-5.61-43.45a9.57,9.57,0,0,1,2.09-7.27,11.54,11.54,0,0,1,7.93-4.16h0c4.37-.4,10.39-1.06,17-1.79,14.42-1.57,30.76-3.37,40.38-3.72h.21c6.88-.17,12.9,3.88,14.69,9.91,3,10,3.17,28.89,3.14,49.08C1611.93,1079,1606.06,1084.48,1598.81,1084.65Zm-61.92-61.53a7.24,7.24,0,0,0-5,2.59,5.34,5.34,0,0,0-1.2,4.07l5.61,43.45c.6,4.61,5.07,8,10.39,7.94l51.93-.75h.1c5-.12,9-3.71,9-8.05,0-19.86-.18-38.46-3-47.86-1.24-4.17-5.82-7.12-10.69-6.88-9.46.34-26.44,2.2-40.07,3.7-6.65.72-12.7,1.39-17.09,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M1542.57,1027.36c10.89-1,34.54-4,45.78-4.4,4.76-.17,9,2.61,10.22,6.71,2.37,8,2.46,24,2.44,38.73,0,4.43-4,8-8.94,8.13l-41.49.6c-5.1.07-9.42-3.3-10-7.82l-4.48-34.72C1535.62,1031,1538.54,1027.73,1542.57,1027.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M1643,1038.35a2.85,2.85,0,0,0-2.89,3.85l5.25,18.09a5.5,5.5,0,0,0,5.11,3.75l261.92-6.32a3.91,3.91,0,0,0,3.81-4.09l-.52-11.37a4.23,4.23,0,0,0-4.18-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M1545,1034.14h0a8,8,0,0,1,11.06,2.72l10.68,18.11a2.57,2.57,0,0,0,4.57-.31l24-57.15a2.84,2.84,0,0,1,5.45,1.09c.16,17.3-3.64,50.29-30.61,78.47,0,0-15.37-5.55-28.28-32.18A8.36,8.36,0,0,1,1545,1034.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1596.53,1191.61h-.14l-51.93.76c-7.48.11-13.78-4.9-14.65-11.64l-5.61-43.44a9.57,9.57,0,0,1,2.09-7.27,11.54,11.54,0,0,1,7.93-4.16h0c4.37-.4,10.38-1.06,17-1.79,13.71-1.5,30.78-3.37,40.4-3.72,6.83-.2,13.09,3.82,14.9,9.91,3,10,3.17,28.89,3.14,49.07C1609.65,1186,1603.77,1191.44,1596.53,1191.61Zm-61.92-61.53a7.29,7.29,0,0,0-5,2.59,5.38,5.38,0,0,0-1.19,4.07l5.61,43.45c.6,4.6,5.06,8,10.39,7.94l51.93-.75c4.89-.21,9.09-3.69,9.1-8.05,0-19.86-.18-38.46-3-47.87-1.24-4.16-5.82-7.06-10.69-6.87-9.47.34-26.45,2.2-40.09,3.69-6.64.73-12.68,1.39-17.07,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M1540.29,1134.32c10.89-1,34.54-4,45.78-4.4,4.76-.17,9,2.6,10.22,6.71,2.36,8,2.46,24,2.44,38.73,0,4.42-4,8.05-8.94,8.12l-41.49.6c-5.1.08-9.42-3.3-10-7.82l-4.48-34.72C1533.34,1138,1536.26,1134.69,1540.29,1134.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M1640.75,1145.31a2.85,2.85,0,0,0-2.89,3.84l5.24,18.1a5.51,5.51,0,0,0,5.12,3.74l261.92-6.31a3.91,3.91,0,0,0,3.81-4.1l-.52-11.36a4.25,4.25,0,0,0-4.19-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M1542.67,1141.09h0a8,8,0,0,1,11.06,2.73l10.68,18.11a2.57,2.57,0,0,0,4.57-.31l24-57.15a2.84,2.84,0,0,1,5.45,1.09c.16,17.3-3.64,50.29-30.61,78.47,0,0-15.37-5.55-28.28-32.19A8.36,8.36,0,0,1,1542.67,1141.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1593.29,1301.93h-.14l-51.93.76c-7.48.11-13.78-4.9-14.65-11.64l-5.61-43.44a9.57,9.57,0,0,1,2.09-7.27,11.54,11.54,0,0,1,7.93-4.16h0c4.37-.4,10.39-1.06,17-1.79,14.41-1.58,30.76-3.37,40.38-3.72,7-.08,13.1,3.82,14.9,9.91,3,10,3.17,28.89,3.14,49.08C1606.41,1296.28,1600.54,1301.76,1593.29,1301.93Zm-61.92-61.53a7.24,7.24,0,0,0-5,2.59,5.34,5.34,0,0,0-1.2,4.07l5.61,43.45c.6,4.6,5.07,8,10.39,7.94l51.93-.75h.1c5-.11,9-3.71,9-8,0-19.86-.18-38.46-3-47.87-1.24-4.16-5.82-7-10.69-6.87-9.46.34-26.44,2.2-40.07,3.69-6.65.73-12.7,1.4-17.09,1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M1537.05,1244.64c10.89-1,34.54-4,45.78-4.4,4.76-.17,9,2.6,10.22,6.71,2.37,8,2.46,24,2.44,38.73,0,4.43-4,8-8.94,8.12l-41.49.61c-5.1.07-9.42-3.31-10-7.83l-4.48-34.72C1530.1,1248.27,1533,1245,1537.05,1244.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M1637.51,1255.63a2.85,2.85,0,0,0-2.89,3.84l5.25,18.1a5.47,5.47,0,0,0,5.11,3.74L1906.9,1275a3.91,3.91,0,0,0,3.81-4.1l-.52-11.36a4.22,4.22,0,0,0-4.18-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M1539.43,1251.42h0a8,8,0,0,1,11.06,2.72l10.68,18.11a2.57,2.57,0,0,0,4.57-.31l24-57.15a2.84,2.84,0,0,1,5.45,1.09c.16,17.3-3.64,50.29-30.61,78.47,0,0-15.37-5.55-28.28-32.18A8.36,8.36,0,0,1,1539.43,1251.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1738.94,545.8c-16.57-11.73-31.06-11.62-41.29-8.7A20.36,20.36,0,0,0,1683,558.38l4,48,52.31,5.08S1771.44,568.81,1738.94,545.8Zm-23.34,38.55a13.06,13.06,0,1,1,13.16-13A13.06,13.06,0,0,1,1715.6,584.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1691.52,587.44a2.59,2.59,0,0,1-1.67-2.21l-.64-7.66a2.59,2.59,0,0,1,5.17-.42l.64,7.65a2.59,2.59,0,0,1-2.37,2.8A2.65,2.65,0,0,1,1691.52,587.44Zm-1.25-15a2.61,2.61,0,0,1-1.67-2.21l-.48-5.81a20.74,20.74,0,0,1,14.9-21.65,40.37,40.37,0,0,1,19.78-.66,2.62,2.62,0,0,1,2,3.08,2.59,2.59,0,0,1-3.07,2,35.33,35.33,0,0,0-17.28.56A15.57,15.57,0,0,0,1693.28,564l.49,5.81a2.59,2.59,0,0,1-2.37,2.8A2.68,2.68,0,0,1,1690.27,572.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1615.32,636.88l.2-24.15a14.73,14.73,0,0,1,15.36-14.59l166.4,7.07A14.35,14.35,0,0,1,1811,618.79l1.2,23.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1670.46,607.8a1.51,1.51,0,0,1,0-3l7.16.06a1.51,1.51,0,1,1,0,3l-7.16-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1623.49,630.53a2.59,2.59,0,0,1-1.68-2.45l.08-9.76A15,15,0,0,1,1637,603.43l26.32.21a2.6,2.6,0,0,1,0,5.19l-26.31-.22a9.84,9.84,0,0,0-9.91,9.75l-.09,9.77a2.59,2.59,0,0,1-2.61,2.57A2.43,2.43,0,0,1,1623.49,630.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1563.24,627.61l291.07,2.4a21.51,21.51,0,0,1,21.06,18l.23,1.43a18.48,18.48,0,0,1-18.38,21.48l-298.63-2.47a12,12,0,0,1-11.9-12.69l.76-13.36A15.69,15.69,0,0,1,1563.24,627.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M835.36,1425c11.38,1,31.13,2.58,46.7,3.27,9.36.41,14.75-.51,17.85-1.75q0,.52,0,1a3.22,3.22,0,0,1-3.06,3,546.66,546.66,0,0,1-61.15.06,2.3,2.3,0,0,1-1.87-3.45A18.92,18.92,0,0,1,835.36,1425Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M882.06,1428.26c-15.57-.69-35.32-2.29-46.7-3.27,11.19-13.73,46.7-23,46.7-23h10a42.15,42.15,0,0,1,7.82,24.5C896.81,1427.75,891.42,1428.67,882.06,1428.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M893.78,1385.64l-.94,18.57a4.25,4.25,0,0,1-3.62,4,16.57,16.57,0,0,1-7.54-.62,5,5,0,0,1-3.37-3.86l-3.25-18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1024.05,1428.12c4.93-.69,7.16-3.26,8.1-6l0,.08c.72,2.89-1,5.88-4.32,7.31a28.17,28.17,0,0,1-12,1.87c-3.7-.15-7.1-1.68-9-4.13l0,0C1010.6,1429.05,1015.82,1429.26,1024.05,1428.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1000.78,1385.52h8.27c12.6-.26,20.51,26.31,23.1,36.6-.94,2.74-3.17,5.31-8.1,6-8.23,1.14-13.45.93-17.17-.91-6.81-9-10.18-22.08-11.8-29.73A10.43,10.43,0,0,1,1000.78,1385.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1008,1368.28l4.59,18.27a5,5,0,0,1-2.58,5.62c-2.57,1.31-6.19,2.7-9.51,2.3a4.16,4.16,0,0,1-3.38-2.76l-6.74-19.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1013.47,1373.56c-5.72,5.07-24.31,5.74-24.31,5.74-66.95-160.69-94.33-183.52-94.33-183.52,9.66,60.65,1.55,194.93,1.55,194.93-11,4.87-25.29,0-25.29,0a1034.61,1034.61,0,0,0-34.19-254.16c45.25-1,69.32-16.5,77.18-22.72C951.8,1174.64,1013.47,1373.56,1013.47,1373.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M902.58,929c8.57,42.72,5.5,119.19,3.48,154.06-.56,9.81,6.28,23.4,11.81,32.67a2.91,2.91,0,0,1-1.17,4.09c-9.26,4.76-40.64,19.51-77,21.34a5.16,5.16,0,0,1-5.21-3.87c-27-100.71-58.3-165.06-58.3-165.06C810.77,917,902.58,929,902.58,929Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M890.26,1192a2.16,2.16,0,0,0,1.83-3.26,67.3,67.3,0,0,0-26.55-23,2.14,2.14,0,1,0-1.86,3.86A64.2,64.2,0,0,1,888.43,1191,2.14,2.14,0,0,0,890.26,1192Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M956.31,1051.65c-2.75,19.9-10.88,41.61-27.14,64.67l-6.18-5a191,191,0,0,0,3.08-61.8C936.1,1047.52,947.94,1049.54,956.31,1051.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M893,981.75,902.58,929s63.92,48.86,53.73,122.61c-8.37-2.11-20.21-4.13-30.24-2.17C923.14,1025.81,914.41,1000.11,893,981.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M776.19,972.27l24.67,53.14c-4,32.08-21.22,45.95-39.8,51.27a112.85,112.85,0,0,0-8.29-34.61C776.51,1017.56,776.19,972.27,776.19,972.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M752.77,1042.07a112.85,112.85,0,0,1,8.29,34.61c-49.58,19.23-62.7-18.07-62.7-18.07l9.17-1.62C728.22,1059.17,742.67,1052.5,752.77,1042.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M798.92,906.67l11.91,43.79a8.52,8.52,0,0,0,11.39,5.67,172.94,172.94,0,0,0,17.17-7.85,11.47,11.47,0,0,0,4.05-16.49l-24.77-36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M675.64,1029.31l305.21,111.08A23.38,23.38,0,0,1,994.14,1172l-.93,2a21.73,21.73,0,0,1-28.9,10.73L668,1047.69Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 535.36,
    cy: 962.49,
    rx: 150.67,
    ry: 147.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M367.7,962.49c0,90.92,75.06,164.62,167.66,164.62S703,1053.41,703,962.49,628,797.86,535.36,797.86,367.7,871.57,367.7,962.49Zm24.63,0c0-77.57,64-140.45,143-140.45s143,62.88,143,140.45-64,140.44-143,140.44S392.33,1040.05,392.33,962.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M690.26,982.24h-.06a.48.48,0,0,1-.42-.54c.49-3.85.84-7.78,1-11.68a.46.46,0,0,1,.51-.46.49.49,0,0,1,.46.51c-.19,3.92-.54,7.88-1,11.76A.49.49,0,0,1,690.26,982.24Zm-1.15-46a.49.49,0,0,1-.48-.4,150,150,0,0,0-9-30.63,153.25,153.25,0,0,0-56.32-68.76,158.13,158.13,0,0,0-171.59-2.87.49.49,0,0,1-.51-.83,159.1,159.1,0,0,1,172.64,2.9,154.26,154.26,0,0,1,56.68,69.19,150.52,150.52,0,0,1,9,30.83.48.48,0,0,1-.39.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M925.53,1110.4l-28.85-2.35-12.49,11.52s2.95,4.09,12.19,1.74,21.91-2.93,21.91-2.93,12.76,5.76,12.91-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M702,1065.43c-2.5,2-11-2.12-16.28-4.93a6,6,0,0,1-2.91-7.11c1.26-4,3.36-9.1,5.95-9.74C693.08,1042.57,712.32,1057.4,702,1065.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M974.83,1179.88a.47.47,0,0,1-.45-.33.48.48,0,0,1,.3-.62c8.88-3.07,13.54-8.08,13.83-14.9a16.55,16.55,0,0,0-10.81-15.92l-36.65-14.29a.5.5,0,0,1-.28-.63.48.48,0,0,1,.63-.27l36.65,14.29a17.51,17.51,0,0,1,11.43,16.87c-.31,7.25-5.19,12.55-14.49,15.77A.41.41,0,0,1,974.83,1179.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M929.93,1129.45l-.17,0-4.75-1.85a.49.49,0,0,1-.28-.63.5.5,0,0,1,.63-.28l4.75,1.85a.49.49,0,0,1-.18.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M796.34,863.68s-9.85,22.65-10.52,34.54-3.22,19.6,10.52,22,25.33-4.45,31.6-16.29c0,0,9.83-18.25,7.62-25.72S796.34,863.68,796.34,863.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M823.24,895.41h-1.73s7.16-14.69.86-17.27-31.2-7.66-36.58-16.5c-5.18-8.52-.56-19.53,6.36-22.62a.93.93,0,0,1,1.17.44l.58,1.08a.93.93,0,0,0,1.72-.17h0a.92.92,0,0,1,1.67-.26c1.65,2.64,6.1,6.94,18.05,9.15,17,3.13,28.17,10,28.45,21.71a.94.94,0,0,0,1.45.77c1.25-.77,3.25-1.12,5.93,1.13,4.65,3.91,2.75,14.07-7.46,22.43a.92.92,0,0,0,0,1.49c1.85,1.21,4.6,4.07-2.54,7.89-7.32,3.91-11.64,3.49-13.28,3.07a.92.92,0,0,1-.7-1l.64-10.38a.93.93,0,0,0-.93-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M822.82,897.58s3.76-14.47,10.24-10.41-3.36,16.21-8.58,16.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "463.25 937.04 520.3 981.44 629.82 891.67 658.08 923.93 520.3 1068.09 432.02 971.39 463.25 937.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1848.34,333.41c-76.18-2-453-14.05-530.36-16.52-7.63-.24-13.89,10.95-13.89,24.85V406c0,13.73,6.11,24.85,13.65,24.85h530.39c7.54,0,13.65-11.12,13.65-24.85V358.26C1861.78,344.68,1855.8,333.61,1848.34,333.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M1344,415.31,1363.69,405a5.28,5.28,0,0,1,4.89,0l19.65,10.38a5.26,5.26,0,0,0,7.63-5.53l-3.72-21.91a5.26,5.26,0,0,1,1.51-4.64l15.94-15.49a5.25,5.25,0,0,0-2.89-9l-22-3.23a5.25,5.25,0,0,1-4-2.88L1371,332.8a5.25,5.25,0,0,0-9.42,0l-9.87,19.91a5.24,5.24,0,0,1-4,2.87l-22,3.16a5.25,5.25,0,0,0-2.92,8.95l15.89,15.53a5.28,5.28,0,0,1,1.5,4.65l-3.79,21.9A5.25,5.25,0,0,0,1344,415.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M1445.58,418.21l19.68-10.31a5.25,5.25,0,0,1,4.89,0l19.66,10.37a5.25,5.25,0,0,0,7.62-5.52l-3.72-21.91a5.24,5.24,0,0,1,1.52-4.64l15.93-15.49a5.25,5.25,0,0,0-2.89-9l-22-3.23a5.25,5.25,0,0,1-4-2.88l-9.8-19.94a5.25,5.25,0,0,0-9.42,0l-9.87,19.91a5.2,5.2,0,0,1-4,2.86l-22,3.17a5.25,5.25,0,0,0-2.92,8.95l15.89,15.53a5.28,5.28,0,0,1,1.5,4.65l-3.79,21.9A5.25,5.25,0,0,0,1445.58,418.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M1548,418.78l19.68-10.31a5.25,5.25,0,0,1,4.89,0l19.65,10.37a5.25,5.25,0,0,0,7.63-5.52l-3.72-21.91a5.23,5.23,0,0,1,1.51-4.64l15.94-15.49a5.25,5.25,0,0,0-2.9-9l-22-3.23a5.25,5.25,0,0,1-4-2.88L1575,336.27a5.24,5.24,0,0,0-9.41,0l-9.87,19.91a5.2,5.2,0,0,1-4,2.86l-22,3.17a5.25,5.25,0,0,0-2.92,8.95l15.88,15.53a5.26,5.26,0,0,1,1.51,4.65l-3.79,21.9A5.25,5.25,0,0,0,1548,418.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M1647.49,419.94l19.69-10.31a5.23,5.23,0,0,1,4.88,0L1691.72,420a5.24,5.24,0,0,0,7.62-5.52l-3.72-21.91a5.27,5.27,0,0,1,1.52-4.65l15.94-15.48a5.25,5.25,0,0,0-2.9-9l-22-3.23a5.27,5.27,0,0,1-4-2.88l-9.8-19.94a5.25,5.25,0,0,0-9.42,0l-9.86,19.91a5.25,5.25,0,0,1-4,2.87l-22,3.16a5.25,5.25,0,0,0-2.92,8.95l15.89,15.54a5.25,5.25,0,0,1,1.5,4.65l-3.79,21.9A5.25,5.25,0,0,0,1647.49,419.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1756,1439.51a6.1,6.1,0,0,0,6.18-4.67l97.71-517.21c.58-3.06-1.73-6-5.15-6.47s-6.66,1.54-7.24,4.6L1749.84,1433c-.58,3,1.72,6,5.14,6.46A6.39,6.39,0,0,0,1756,1439.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M2085.66,1439.52a6.69,6.69,0,0,0,1.25-.12c3.4-.61,5.6-3.57,4.91-6.61L1976.65,922.31c-.69-3-4-5-7.4-4.39s-5.6,3.57-4.92,6.61L2079.51,1435A6.16,6.16,0,0,0,2085.66,1439.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.59,1045.44h167c3.47,0,6.28-2.51,6.28-5.61s-2.81-5.61-6.28-5.61h-167c-3.47,0-6.28,2.51-6.28,5.61S1827.12,1045.44,1830.59,1045.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1833.62,1045.44h160.91a5.63,5.63,0,1,0,0-11.22H1833.62a5.63,5.63,0,1,0,0,11.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.59,1139h167c3.47,0,6.28-2.51,6.28-5.61s-2.81-5.61-6.28-5.61h-167c-3.47,0-6.28,2.51-6.28,5.61S1827.12,1139,1830.59,1139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1815.43,1139h202.42c3.47,0,6.29-2.51,6.29-5.61s-2.82-5.61-6.29-5.61H1815.43c-3.47,0-6.28,2.51-6.28,5.61S1812,1139,1815.43,1139Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.59,1232.48h167c3.47,0,6.28-2.51,6.28-5.61s-2.81-5.61-6.28-5.61h-167c-3.47,0-6.28,2.51-6.28,5.61S1827.12,1232.48,1830.59,1232.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1796.09,1232.48H2038.4c3.47,0,6.28-2.51,6.28-5.61s-2.81-5.61-6.28-5.61H1796.09c-3.46,0-6.28,2.51-6.28,5.61S1792.63,1232.48,1796.09,1232.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1830.59,1326h227.29c3.46,0,6.28-2.51,6.28-5.61s-2.82-5.61-6.28-5.61H1830.59c-3.47,0-6.28,2.51-6.28,5.61S1827.12,1326,1830.59,1326Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1780.45,1326h277.43c3.46,0,6.28-2.51,6.28-5.61s-2.82-5.61-6.28-5.61H1780.45c-3.46,0-6.28,2.51-6.28,5.61S1777,1326,1780.45,1326Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M594.83,617.27l-7.2-31.59H555l-7.2,31.59H524.52l31-125.7h31.6l31.08,125.7ZM583.27,565l-6.68-29.11q-.6-2.65-2.7-13.32t-2.53-14.26q-1.11,7.36-2.82,16.23T559.63,565Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M697.5,530.62q0,19.95-10.07,30.61t-29.07,10.66h-5.82v45.38H629.25V492.08H661Q697.5,492.08,697.5,530.62Zm-45,21.06H657q8.57,0,12.76-4.71t4.2-15.41q0-9.85-3.86-14.6t-11.9-4.75h-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M781.5,530.62q0,19.95-10.06,30.61t-29.07,10.66h-5.83v45.38H713.25V492.08H745Q781.5,492.08,781.5,530.62Zm-45,21.06H741c5.7,0,10-1.57,12.75-4.71s4.2-8.28,4.2-15.41q0-9.85-3.85-14.6t-11.91-4.75h-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M820.55,568.55v48.72H797.26V492.08h30.48q19.35,0,28.56,9.16t9.2,28q0,23.71-16,33.13l24.06,54.89H848.63l-19.78-48.72Zm0-20h6q8.22,0,11.82-4.66T842,529.93q0-9.58-3.81-13.66t-11.77-4.06h-5.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M971.08,554.51q0,31.08-11.64,47.78T926.13,619q-21.75,0-33.4-16.66t-11.64-48q0-31.1,11.64-47.66t33.57-16.57q21.66,0,33.22,16.66T971.08,554.51Zm-66.19,0q0,21.4,5.4,32.62t15.84,11.22q21.06,0,21.06-43.84T926.3,510.66q-10.62,0-16,11.18T904.89,554.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1043.18,492.08h23.47l-29.46,125.19h-29.63L978.28,492.08h23.46l16.35,76.47a281.61,281.61,0,0,1,4.37,28q1.8-15.49,4.54-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1134.12,617.27h-56.43V492.08h56.43v20.13H1101V542h30.74v20.2H1101v34.68h33.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1232,553.48q0,31-12.63,47.4T1183,617.27h-30.66V492.08h33.49q21.83,0,34,16.14T1232,553.48Zm-23.89.68q0-42-23.12-41.95h-9.33v84.68h7.53q12.76,0,18.84-10.66T1208.11,554.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M953.54,868.75a5.71,5.71,0,0,1-5.46-2.59l-6.75-10.54A68.84,68.84,0,0,1,924,852.9l-9.65,8a5.69,5.69,0,0,1-6.59.46L892.42,852a5.69,5.69,0,0,1-2.6-6.09l2.68-12.22a69.5,69.5,0,0,1-10.37-14.21l-12.46-1.18a5.7,5.7,0,0,1-5-4.32l-4.22-17.42a5.69,5.69,0,0,1,2.47-6.13l10.53-6.75a69.24,69.24,0,0,1,2.73-17.38l-8-9.65a5.71,5.71,0,0,1-.47-6.59l9.33-15.3a5.69,5.69,0,0,1,6.08-2.59l12.23,2.68a69.17,69.17,0,0,1,14.21-10.38L910.75,712a5.69,5.69,0,0,1,4.32-5l17.42-4.22a5.67,5.67,0,0,1,6.12,2.45l6.76,10.55a69.75,69.75,0,0,1,17.38,2.72l9.65-8a5.71,5.71,0,0,1,6.58-.48l15.31,9.34a5.7,5.7,0,0,1,2.59,6.07l-2.68,12.24A69.17,69.17,0,0,1,1004.58,752l12.46,1.18a5.69,5.69,0,0,1,5,4.32l4.22,17.41a5.71,5.71,0,0,1-2.46,6.14l-10.54,6.75a69.75,69.75,0,0,1-2.72,17.38l8,9.65a5.71,5.71,0,0,1,.47,6.59l-9.33,15.29a5.68,5.68,0,0,1-6.07,2.6l-12.24-2.68A69.5,69.5,0,0,1,977.13,847L976,859.41a5.7,5.7,0,0,1-4.32,5l-17.42,4.22C954,868.68,953.76,868.72,953.54,868.75ZM922,842.92l2.34.77a60.72,60.72,0,0,0,19.4,3l2.46,0,8.14,12.7,12.93-3.13,1.42-15,2.19-1.11a60.57,60.57,0,0,0,15.86-11.58l1.73-1.75,14.74,3.23,6.93-11.36-9.62-11.63.77-2.34a60.4,60.4,0,0,0,3-19.4l0-2.46,12.7-8.14-3.13-12.92-15-1.43-1.11-2.19a60.34,60.34,0,0,0-11.58-15.86l-1.75-1.73,3.23-14.74-11.36-6.93-11.63,9.62-2.34-.77a60.4,60.4,0,0,0-19.4-3l-2.46,0-8.13-12.7-12.93,3.13-1.42,15-2.2,1.11a60.7,60.7,0,0,0-15.86,11.57l-1.73,1.76-14.74-3.23-6.93,11.36,9.62,11.63-.77,2.34a60.63,60.63,0,0,0-3,19.4l0,2.46-12.7,8.13,3.13,12.93,15,1.42,1.11,2.2a60.34,60.34,0,0,0,11.58,15.86l1.75,1.73L899,845.61l11.36,6.93ZM908.61,854Zm-10.07-6.16h0Zm-1.48-3.44h0Zm-12.38-105h0Zm63.8,93.51a47.7,47.7,0,1,1,40.88-58.61,48.2,48.2,0,0,1,1.34,10.06,4.46,4.46,0,1,1-8.92.23,39.15,39.15,0,0,0-1.09-8.19,38.77,38.77,0,1,0-10.5,36.78,4.46,4.46,0,1,1,6.26,6.36,47.81,47.81,0,0,1-28,13.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M945.72,806a20.38,20.38,0,1,1,15.65-29.74h0A20.39,20.39,0,0,1,945.72,806ZM942,774.35a11.51,11.51,0,0,0-4,1.25,11.44,11.44,0,1,0,15.46,4.79h0a11.52,11.52,0,0,0-11.46-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M813,768.64a3.76,3.76,0,0,1-1.45-.1l-8.34-2.16a4,4,0,0,1-2.94-3.49l-.43-5.39a35,35,0,0,1-6-4.5l-5.28,1.07a3.94,3.94,0,0,1-4.17-1.85l-4.38-7.44a3.92,3.92,0,0,1,.4-4.55l3.5-4.1a33.86,33.86,0,0,1-1-7.43l-4.5-3a4,4,0,0,1-1.64-4.28l2.16-8.34a4,4,0,0,1,3.5-2.94l5.38-.42a33.81,33.81,0,0,1,4.51-6l-1.08-5.28a4,4,0,0,1,1.87-4.18l7.42-4.37a3.92,3.92,0,0,1,4.56.4l4.09,3.49a35,35,0,0,1,7.43-1l3-4.5a3.94,3.94,0,0,1,4.27-1.63l8.34,2.15a4,4,0,0,1,2.94,3.49l.42,5.39a34.8,34.8,0,0,1,6,4.51l5.28-1.07A3.94,3.94,0,0,1,851,703l4.36,7.4a3.92,3.92,0,0,1-.38,4.54l-3.51,4.12a35,35,0,0,1,1,7.42l4.5,3a4,4,0,0,1,1.64,4.28l-2.16,8.33A4,4,0,0,1,853,745l-5.39.43a35.19,35.19,0,0,1-4.51,6l1.07,5.28a3.91,3.91,0,0,1-1.85,4.17l-7.43,4.38a3.92,3.92,0,0,1-4.57-.41l-4.09-3.49a34.48,34.48,0,0,1-7.42,1l-3,4.49A3.9,3.9,0,0,1,813,768.64Zm-2.76-5.44v0Zm24.41-3.45,0,0Zm-3.16-.26h0Zm-24.7.91,4.53,1.17,3.91-5.89,1.84,0a27.74,27.74,0,0,0,9-1.26l1.76-.55,5.37,4.59,4-2.38-1.4-6.92,1.33-1.28a28,28,0,0,0,5.45-7.23l.86-1.64,7-.56L851.7,734l-5.89-3.9.05-1.85a28.05,28.05,0,0,0-1.26-9l-.55-1.76,4.58-5.37-2.38-4-6.92,1.4-1.27-1.33a27.83,27.83,0,0,0-7.24-5.45l-1.63-.86-.56-7-4.54-1.17-3.9,5.89-1.85,0a28,28,0,0,0-9,1.25l-1.77.55-5.37-4.58-4,2.38,1.41,6.92-1.34,1.27a28,28,0,0,0-5.44,7.24l-.86,1.63-7,.56-1.18,4.54,5.89,3.9,0,1.85a28,28,0,0,0,1.26,9l.55,1.77-4.58,5.37,2.37,4,6.92-1.41,1.28,1.34a27.92,27.92,0,0,0,7.23,5.44l1.64.86ZM837.64,758h0Zm-52.09-13.47Zm.27-3.19h0Zm66.38-9.33s0,0,0,0Zm-2.57-18.25h0Zm-1.44-6.12h0Zm-2.93-1.3v0Zm2.25-2h0Zm-51-4.34h0Zm34-4.78h0Zm-8.34-2.15Zm-21.44,2.29h0Zm19.62,56.13a24.18,24.18,0,0,1-8.86-.62,24.14,24.14,0,0,1-6.22-44.17,24.18,24.18,0,0,1,33.06,8.55,23.75,23.75,0,0,1,2.12,4.68,3.34,3.34,0,1,1-6.35,2.1,17.75,17.75,0,0,0-1.54-3.38,17.44,17.44,0,0,0-31.92,4.49,17.44,17.44,0,0,0,32.2,12.72,3.35,3.35,0,1,1,5.88,3.2,24.22,24.22,0,0,1-18.37,12.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M1775.54,477.25l37.85-23.64a10.56,10.56,0,0,1,9.79-.72l40.93,17.78a10.55,10.55,0,0,0,14.44-12.22l-10.79-43.31a10.54,10.54,0,0,1,2.34-9.53l29.56-33.43a10.55,10.55,0,0,0-7.17-17.51L1848,351.55a10.56,10.56,0,0,1-8.35-5.17L1817,307.94a10.55,10.55,0,0,0-18.86,1.4l-16.73,41.37a10.56,10.56,0,0,1-7.49,6.35l-43.57,9.67a10.54,10.54,0,0,0-4.49,18.37L1760,413.8a10.53,10.53,0,0,1,3.72,9.08l-4.26,44.42A10.54,10.54,0,0,0,1775.54,477.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1868.2,448.32s-62.07,79.48,8.75,160.31l26.63-2.48c-1.54.14-7.87-14.31-8.51-15.57a275.77,275.77,0,0,1-16.42-40.29c-5.43-17.18-9.1-35.1-9.34-53.16a121.24,121.24,0,0,1,2.68-27.72c1.14-5.2,3.08-9.2,8.23-11.33,5.59-2.31,10.71-6.2,13.51-11.56a20.37,20.37,0,0,0-9.63-28c-1.67-.8-14.49-3.76-14.49-1.57,0,5.08,3.16,9.52,5.23,14.15C1878.7,439.76,1875.31,444,1868.2,448.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1902.2,837.43s50.29,109.61,76.68,155c0,0,5.24,28.56,0,37.55l-4.47,2,20.85-.62s1.85-38.42.4-40.57a5.3,5.3,0,0,0-4.34-2s-8.93-70.81-34.82-85.92l-25.08-86.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M1965.51,1037.36c0,.51,16.28.28,25.14.12a7,7,0,0,0,6.75-5.56l6.69-35.15a6.31,6.31,0,0,0-4.8-7.34l-3.73-.85s-5.33,7.31-3.65,14.18,3.17,24.71-1.07,26.78-16.43,2.44-16.43,2.44S1965.79,1032.84,1965.51,1037.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M1854.53,1038a1.84,1.84,0,0,0,.93,3.44c14.82-.15,48-.62,51-1.84,3.81-1.59-1.39-15.28-6.87-19.92l-30.21,9.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M1845.15,830.44s32.5,157.22,41.7,187.89L1865.1,1032s10.9-1.85,19-2.44,15.51-9.86,15.51-9.86l-2.6-4.15s-8.15-156.37-6.17-174.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1831.86,581.16c12.46,3.45,54.66,14.56,81,14.1l-16.18,91.29,1.29,14.89-52.74-.24s-14.85-34.48-26.56-51.67c-3.39-5-.87-10.89,1-16.58l-2.64-1.76a7.16,7.16,0,0,1-2.84-8.19l12.84-39.3A3.93,3.93,0,0,1,1831.86,581.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1841,693.41l1,9s-14.91,44.64,7.45,148.9c0,0,48.42,13.71,88.22-19.11,0,0-11.23-98.4-14.29-103-15.27-22.83-25.45-27.79-25.45-27.79l-.46-9.85S1855,699.28,1841,693.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M1861.66,588.52c-.19-.25,11-33.81,11-33.81l16,1.46,6.26,38.07S1869.84,599.31,1861.66,588.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M1884.87,501.79c-1.07.67-34.27,14.39-27.14,48.86a6.48,6.48,0,0,0,3.68,4.61,56.34,56.34,0,0,0,27.91,4.62c17.39-1.77,28.79-32.12,28.3-41S1895.47,495.19,1884.87,501.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M1895,488.39c-.87.12-19.18,6.49-10.1,19.76s12.49,21.09,8.19,26.91c-3.91,5.31-12.58,2.29-11.83,13.33a6.16,6.16,0,0,1-2.64,5.6c-8.17,5.53-28.1,22.55-8.35,46.83a6.17,6.17,0,0,1,.7,6.92c-5.79,10.37-17.93,40.76,26,57.62,43.46,16.65,59.15-11.76,63.54-23.11a6,6,0,0,1,6-3.84c4.78.23,11.55-.57,11.23-6.95-.18-3.87-2.6-7.35-5.46-10.13a6.06,6.06,0,0,1,1.16-9.54,11.83,11.83,0,0,0,5.86-7.36c2.64-9.76-2.62-38.95-30.6-43.89a6.61,6.61,0,0,1-5.11-4.95s0-.07,0-.1a6.05,6.05,0,0,1,2.25-6c4.46-3.28,10.19-9.87,5.54-20.45-4.13-9.38-12-12.55-17.92-13.56a6.09,6.09,0,0,1-5-7.28C1930.44,498.92,1928.71,484,1895,488.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M1764.47,463.71s-4.48,81.78,70,123.58l-17.92,40.89s-67.42-40.78-64.93-152a12.92,12.92,0,0,0-3.16-8.7l-14.33-16.63a25.7,25.7,0,0,1-5.47-23l1.89-7.54a3.9,3.9,0,0,1,5.75-2.43l1.5.87a26.3,26.3,0,0,1,10.8,12l7.2,11.36c2.62,5.87,3.24,8.34,9.65,7.78l11.92.14Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityAssurance1);
export default __webpack_public_path__ + "static/media/quality_assurance_1.2e425debfe9d11fabf942c185c33cdc4.svg";
export { ForwardRef as ReactComponent };